import { Routes } from '../type';

type VisualRoutes = (routes: Routes) => Routes;
export const visualRoutes: VisualRoutes = routes => routes
    .filter(route => parseInt(route.sort) >= 0);
